import { Announcement } from 'src/models/entity';

import { ListResponse } from 'src/models/api/response/ListResponse';

import { apiGet } from 'src/utils/api/api-utils';

export const fetchAnnouncements = () =>
  apiGet<ListResponse<Announcement>>('announcement')
    .then((response) => response.data);
